import React, { useState } from 'react';

const About = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    fetch("https://formcarry.com/s/ZOn-NOo85qx", {
      method: 'POST',
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ name, email, message })
    })
    .then(response => response.json())
    .then(response => {
      if (response.code === 200) {
        alert("We received your submission, thank you!");
        setName('');
        setEmail('');
        setMessage('');
      } else if (response.code === 422) {
        setError(response.message);
      } else {
        setError(response.message);
      }
    })
    .catch(error => {
      setError(error.message ? error.message : error);
    });
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <div style={{ backgroundColor: '#441B77' }} className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="mt-20 text-5xl font-bold text-white mb-6">
            Welcome to T4
          </h1>
          <p className="text-2xl text-white/90 mb-8">
            Time to Transform Travel Tradition in India & Abroad
          </p>
          <div className="flex justify-center gap-4">
            <a
              href="#about"
              style={{ backgroundColor: '#441B77', border: '2px solid #ffffff' }}
              className="px-8 py-3 text-white rounded-full font-semibold hover:bg-white hover:text-[#441B77] transition-all"
            >
              Learn More
            </a>
            <a
              href="#contact"
              style={{ backgroundColor: '#441B77', border: '2px solid #ffffff' }}
              className="px-8 py-3 bg-transparent text-white rounded-full font-semibold hover:bg-white hover:text-[#441B77] transition-all"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* About Content */}
      <div id="about" className="max-w-7xl mx-auto px-4 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Transforming Your Travel Experience
          </h2>
          <div className="space-y-6">
            <p className="text-gray-700 leading-relaxed">
              After a decade of experience in the hospitality management business, we are absolutely awestruck by the potential this initiative holds. With extensive research expertise in the pre-purchase concept, T4 is set to revolutionize the way we experience travel.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Imagine a world where every journey is tailored to your unique preferences, blending traditional practices with innovative ideas. T4 isn't just about travel; it's about transforming how we perceive and engage with different cultures, landscapes, and experiences.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-blue-50 py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div
              style={{ backgroundColor: '#441B77', color: '#ffffff' }}
              className="p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6">
                <span className="text-2xl">✈️</span>
              </div>
              <h3 className="text-xl font-bold mb-4">Personalized Journeys</h3>
              <p className="text-white/90">Tailored travel experiences designed around your unique preferences and interests.</p>
            </div>
            <div
              style={{ backgroundColor: '#441B77', color: '#ffffff' }}
              className="p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6">
                <span className="text-2xl">🌏</span>
              </div>
              <h3 className="text-xl font-bold mb-4">Cultural Immersion</h3>
              <p className="text-white/90">Deep connections with local traditions and authentic experiences worldwide.</p>
            </div>
            <div
              style={{ backgroundColor: '#441B77', color: '#ffffff' }}
              className="p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6">
                <span className="text-2xl">🎯</span>
              </div>
              <h3 className="text-xl font-bold mb-4">Expert Planning</h3>
              <p className="text-white/90">Decade of expertise ensuring seamless and memorable travel experiences.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact" className="max-w-7xl mx-auto px-4 py-20">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Get in Touch</h2>
            
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg mb-6">
                {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Full Name</label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="Your first and last name"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="john@doe.com"
                  required
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Message</label>
                <textarea
                  id="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all h-32"
                  placeholder="Tell us about your travel dreams..."
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                style={{ backgroundColor: '#441B77' }}
                className="w-full text-white py-3 px-6 rounded-lg hover:bg-[#5A2A8F] transition-colors duration-200 font-semibold"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-xl">📍</span>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Address</p>
                    <p className="text-gray-600">226, Lodha Signet, Kolshet Road,<br />Thane (w) 400607, Maharashtra.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-xl">📞</span>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Phone</p>
                    <p className="text-gray-600">9004180898<br />9082269941</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-xl">✉️</span>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Email</p>
                    <p className="text-gray-600">Info@clubnjoy.com<br />joysureinnovator@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div
              style={{ backgroundColor: '#441B77' }}
              className="rounded-2xl shadow-xl p-8 text-white"
            >
              <h3 className="text-2xl font-bold mb-4">Ready to Start Your Journey?</h3>
              <p className="mb-6">Let us help you transform your travel dreams into reality. Contact us today to begin your adventure.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;